import toast from "react-hot-toast";
import axiosInstance from "./Axios";
import { clientRoutes } from "../routes";

export class AgentEmployeeApi {
  static create = async (data: any) => {
    try {
      const res = await axiosInstance.post(`agent-employee`, data);
      return { data: res.data, success: true };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: err?.response?.data?.message || "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static listReportingManagers = async (params?: any) => {
    try {
      const res = await axiosInstance.get(`agent-employee/reporting-managers`, {
        params,
      });
      return { data: res.data, success: true };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: err?.response?.data?.message || "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static list = async (params?: any) => {
    try {
      const res = await axiosInstance.get(`agent-employee`, { params });
      return { data: res.data, success: true };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: err?.response?.data?.message || "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getById = async (employee_id: string) => {
    try {
      const res = await axiosInstance.get(`agent-employee/${employee_id}`);
      return { data: res.data, success: true };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: err?.response?.data?.message || "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static update = async (employee_id: string, data: any) => {
    try {
      const res = await axiosInstance.patch(
        `agent-employee/${employee_id}`,
        data,
      );
      return { data: res.data, success: true };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: err?.response?.data?.message || "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };
}
